import React from 'react'
import clsx from 'clsx'
import './Input.scss'

import './InputMultiField.scss'

// pass all props to the input element and define the props type

export type TPropsInputMultiField = {
  label?: string
  sublabel?: string
  size?: 'sm' | 'md' | 'lg'
  error?: string
  info?: string
  type?: 'text' | 'number' | 'password' | 'email' | 'url' | 'tel' | 'search' | 'date' | 'time' | 'datetime-local'
  required?: boolean
  postfix?: string
  flexibleWidth?: boolean
  input1: React.InputHTMLAttributes<HTMLInputElement>
  input2: React.InputHTMLAttributes<HTMLInputElement>
  parentStyle?: React.CSSProperties
}

const InputMultiField = (props: TPropsInputMultiField) => {
  const { required, flexibleWidth, input1, input2 } = props
  const renderedLabel = props.label ? (
    <label className="tq-input-label">
      {props.label}
      {required && <span className="tq-input-mandatory">*</span>}
    </label>
  ) : null

  const renderedSublabel = props.sublabel ? <span className="tq-input-sublabel">{props.sublabel}</span> : null

  return (
    <div className="tq-input-wrapper" style={props.parentStyle}>
      {renderedLabel}
      {renderedSublabel}
      <div className="tq-input-multi-field">
        <div
          className={clsx('tq-input-field', { 'flexible-width': flexibleWidth, 'field-small': props.size === 'sm' })}
        >
          <input
            className={clsx('tq-input', {
              'tq-input-number': input1.type === 'number'
            })}
            {...input1}
          />
          {props.postfix && <span className="tq-input-postfix">{props.postfix}</span>}
        </div>
        <div
          className={clsx('tq-input-field', { 'flexible-width': flexibleWidth, 'field-small': props.size === 'sm' })}
        >
          <input
            className={clsx('tq-input', {
              'tq-input-number': input2.type === 'number'
            })}
            {...input2}
          />
          {props.postfix && <span className="tq-input-postfix">{props.postfix}</span>}
        </div>
      </div>
      {props.error && <span className="tq-input-error">{props.error}</span>}
      {props.info && <span className="tq-input-info">{props.info}</span>}
    </div>
  )
}

export default InputMultiField
